module.exports = __webpack_public_path__ + "img/image25@3x.0b1ea889.png";